import { useTranslation as originalUseTranslation } from "react-i18next";
import i18next from "i18next";

export const useTranslation = () => {
    const { t, i18n } = originalUseTranslation();

    const customT = (i18n_string, options) => {
        if (i18n_string.trim() == '') return i18n_string;

        const translation = t(i18n_string, options);

        if (i18n.exists(i18n_string) && translation && translation.trim() != '') {
            return translation;
        } else {
            return t(i18n_string, { ...options, lng: "en" }); // Fallback to English
        }
    };

    return { t: customT, i18n };
};
